/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getNumberOfEmployments} from '../api'

 export const useQueryGetNumberOfEmployments = createReactQueryHook('getNumberOfEmployments', getNumberOfEmployments)
